"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sticky = exports.Question = exports.Content = exports.Answer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Content = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media (min-width: 768px) {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 20px;\n  }\n"])));

exports.Content = Content;

var Question = _styledComponents.default.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0px;\n  ", "\n  ", "\n  ", "\n"])), (0, _layout.setContainer)({
  size: 'xl'
}), (0, _typography.setFont)({
  bold: true
}), (0, _typography.setFontSizes)({
  mobile: '32px',
  desktop: '48px'
}));

exports.Question = Question;

var Sticky = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  /* Add bottom padding to mobile */\n  padding-bottom: 48px;\n\n  /* top is 15px + the header height */\n  @media (min-width: 768px) {\n    position: sticky;\n    padding-bottom: 0;\n    //top: 87px;\n  }\n\n  @media (min-width: 992px) {\n    /* top: 92px; */\n  }\n"])));

exports.Sticky = Sticky;

var Answer = _styledComponents.default.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  ", "\n  ", "\n  ", "\n\n  @media (min-width: 768px) {\n    max-width: 370px;\n  }\n\n  @media (min-width: 1200px) {\n    max-width: 450px;\n  }\n\n  @media (min-width: 1600px) {\n    max-width: 680px;\n  }\n"])), (0, _typography.setFont)({
  bold: false
}), (0, _typography.setFontSizes)({
  mobile: '16px',
  tablet_vertical: '20px'
}), (0, _layout.setContainer)({
  size: 'xl'
}));

exports.Answer = Answer;